<template>
  <v-btn
    class="mb-3 white--text top-button transparent rounded-0 elevation-0"
    @click="sort(ascending)"
  >
    <!-- <v-icon class="px-2" color="white">{{
      ascending ? " mdi-sort-ascending" : "mdi-sort-descending"
    }}</v-icon>
    {{ $t("sort") }} -->
    <v-img
      max-width="85%"
      v-if="ascending == 1"
      title="A to Z"
      src="@/assets/images/a2z.svg"
    ></v-img>
    <v-img
      max-width="85%"
      title="Z to A"
      v-else
      src="@/assets/images/z2a.svg"
    ></v-img>
  </v-btn>
</template>

<script>
import { get } from "lodash";
export default {
  name: "SortButton",
  props: {
    ascending: Boolean,
    list: Array,
    attr: String,
  },
  methods: {
    sort() {
      let order = this.$props.ascending;
      this.$props.ascending = !this.$props.ascending;
      if (order) {
        this.$props.list.sort((a, b) => {
          let aValue = get(a, this.$props.attr);
          let bValue = get(b, this.$props.attr);
          if (aValue < bValue) {
            return -1;
          }
          if (aValue > bValue) {
            return 1;
          }
          return 0;
        });
      } else {
        this.$props.list.sort((a, b) => {
          let aValue = get(a, this.$props.attr);
          let bValue = get(b, this.$props.attr);
          if (aValue < bValue) {
            return 1;
          }
          if (aValue > bValue) {
            return -1;
          }
          return 0;
        });
      }
      this.$emit("sort", {
        list: this.$props.list,
        ascending: this.$props.ascending,
      });
    },
  },
};
</script>
